/* global axios */
import ApiClient from './ApiClient';

class SalesGoalsAPI extends ApiClient {
  constructor() {
    super('sales_goals', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { sales_goal: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { sales_goal: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getCurrent(params = {}) {
    return axios.get(`${this.url}/current`, { params });
  }

  getTeamProgress() {
    return axios.get(`${this.url}/team_progress`);
  }

  getByUser(userId, params = {}) {
    return axios.get(this.url, {
      params: { user_id: userId, ...params },
    });
  }

  getActive() {
    return axios.get(this.url, {
      params: { active: true },
    });
  }
}

export default new SalesGoalsAPI();
